export default class hr {
    static translations = {
        alerts: {
            activeContractAnotherPlacementStart:
                'System found an active Contract associated with this Seafarer. Please Cancel/Complete placement #',
            activeContractAnotherPlacementEnding: '  in order to issue contract for this placement.',
            activeContractCurrentPlacementStart:
                'There is an active contract associated with this placement. Confirming this contract will make it active on ',
            activeContractCurrentPlacementEnding:
                '. Last active contract will become inactive. Would you like to proceed?',
            activeOrConfirmedContractsWillBeDetermined:
                'Active or Confirmed contracts will be determined. Would you like to proceed?',
            allContractDetermined: 'All contracts are cancelled!',
            anonymizationDisabledContractOrPlanned:
                'You cannot anonymizate this seafarer because of active or planned contract!',
            approveExpenseQuestion: 'Are you sure you want to approve this Expense?',
            approveAndSaveSeafarerToDatabase: 'Are you sure you want to approve and add the seafarer to database?',
            archiveQuestion: 'Are you sure you want to archive this record?',
            basicUpdate: 'Changes saved.',
            basicDelete: 'Record deleted.',
            basicAdd: 'Record added.',
            basicError: 'A server error occurred.',
            missingFields: 'Missing fields:',
            cancelContractAlert: 'Are you sure you want to cancel this contract?',
            cannotCreateContractOnThisDateStart:
                'You cannot create new contract for this Seafarer on this date. First available date is ',
            cannotCreateContractOnThisPlacement:
                'You cannot create contract on this placement because of the placement status!',
            cannotCreatePlannedPlacement: 'This Seafarer already has another Placement in status "Planned"!',
            cannotSelectDateInFuture: 'You cannot select date in the future!',
            cannotSelectMoreThanTen: 'You cannot select more than 10 seafarers!',
            changedRankSeniorityNewContractr:
                'You changed rank/seniority on this placement, do you want to proceed and create new contract with updated rank and seniority?',
            changeStatusOnPlacementsCrewList:
                'Are you sure you want to change status for these placements? Once done, this action cannot be reverted.',
            choseActionforCompleteOrCancelPlacement:
                'System found a placement with an active contract. In order to proceed \nyou need to choose to cancel or \n complete the placement on dialog!',
            completePlacementCrewlistChangeStatus:
                'Are you sure you want to \n complete placements? Once \n done, this action cannot be \n reverted.',
            contractDateSpan: 'Please adjust start date for activity for active contract!',
            chooseEntityBeforeSavingBillingList: 'Please select Entity (invoice to) before saving list!',
            creatingPlacement:
                'Saving this record in this status will move this Application to Placement. \nWould you like to proceed?',
            createVacancyQuestion:
                'You are about to cancel this Placement. \nWould you like to create a Vacancy for this placement?',
            createWageTemplateBeforeAddingExpenses:
                'Wage template on Maritime object is necessary before adding expenses! \nCreate Wage template on %name% !',
            currentlyDisabled: 'Currently disabled',
            dateNowOrBefore: 'Please select date in past or today!',
            defineSeniorityForThisPlacement: 'Please define seniority for this placement!',
            defineWageTemplateForRankAndSeniority:
                'Please define wage template for rank and seniority on this placement before creating contract!',
            deleteInvoiceQuestion: 'Are you sure you want to delete this invoice? This action is irreversible!',

            deletionQuestion: 'Are you sure you want to delete this record?',
            deleteError: 'This record cannot be deleted.',
            determineAllContractsOnPlacement:
                'Are you sure you want to determine all contracts on this Placement? Items from billing will not be deleted, you can update them later!',
            emailMissing: 'Email is missing.',
            emailFailFormat: 'Email format is not valid.',
            fileDeletionQuestion: 'Are you sure you want to delete this file?',
            fieldMissing: 'This field is mandatory',
            firstNameMissing: 'Niste unijeli ime.',
            generatePasswordQuestion: 'Are you sure you want to generate a new password for this user?',
            generatingTimesheetError: 'Server error while trying to generate Timesheet!',
            generateTimesheetsAndApproveThem:
                'Confirming this action will generate timesheets on placements for this Entity. \nWould you like to proceed?',
            hasUnapprovedDocsQuestion: 'There are unapproved items in document checklist, would you like to proceed?',
            insertName: 'Insert name for Billing List!',
            invalidBodyMetrics: 'Please enter valid body metrics (numbers only).',
            invoiceDeleteInvalid: 'Invoice is no longer deletable, please return to table view, or refresh this view!',
            invoiceFileLinkNotFound: 'Invoice file link not found!',
            itemExists: 'Item with same rank and seniority already exists!',
            languageAlreadyAdded: 'Selected language is already added to Seafarer',
            lastNameMissing: 'Surname is missing',
            loadTemplate:
                'Loading template from other Maritime Object \nwill owerwrite any previously added data!\nWould you like to proceed?',
            logoutQuestion: 'Logout?',
            loginFail: 'Invalid login information.',
            leaveQuestion: 'Leave without saving?',
            logoMissing: 'Logo is required before saving.',
            missingDocument: 'Document missing!',
            noFilesToAttachToInvoice: 'There are no files to attach to this invoice!',
            noItemsForBilling: 'No items for billing List!',
            noChecklistDefinedOnMaritimeObject: 'There is no Document Checklist defined on Maritime Object',
            noPlacementToAttach: 'No placement to attach this item!',
            payslipCurrencyMismatch:
                'Cannot issue payslip for %seafarer%: seafarer currency (%seafarerCurrency%) does not match the wage template currency (%wageCurrency%). Please change the seafarer\'s account currency to %wageCurrency%.',
            oibFormattFailed: 'OIB is not valid.',
            photoDeletionQuestion: 'Are you sure you want to delete this photo?',
            passwordMissing: 'Password is missing.',
            passwordFailConfirmation: 'Passwords do not match.',
            passwordResetSuccess: 'A new password has been sent to the entered e-mail address.',
            passwordResetFail: 'No user was found with the entered e-mail address.',
            passwordLength: 'The password must have a minimum of 8 characters.',
            passwordLetters: 'Password must have at least one letter.',
            passwordDigits: 'Password must have at least one digit.',
            passwordOthers: 'The password must have at least one special character.',
            payslipFileLinkNotFound: 'Payslip File link not found!',
            pendingRowInvalid: 'Please complete or clear the unfinished row before saving.',
            pdfSentToSeafarer: 'Document sent to seafarer',
            placementCreated: 'Placement created',
            pleaseSelectSeafarers: 'Please select seafarers to continue!',
            rejectExpenseQuestion: 'Are you sure you want to reject this expense? This action is irreversible!',
            cancelPlacementQuestion: 'Are you sure you want to cancel placement?',
            bulkPlanSkippedDeceased: 'Seafarers marked as Deceased were not planned:',
            completePlacementQuestion: 'Are you sure you want to complete placement? ',
            onshoreFacilityNotDefined: 'On shore facility is not defined',
            onlyDocx: 'We accept only .docx documents for contract templates!',
            onlyPdf: 'We accept only .pdf documents!',
            onlyPhoto: 'We accept only photos with .jpg, .jpeg and .png formats!',
            onlyPng: 'We accept only photos with .png formats!',
            placementNotInPLanned:
                'Placement you want to issue this contract is not in "Planned" status. Please change placement status to "Planned" if you want to issue contract',
            recordLocked: 'This record is locked because it is being edited by %name%.',
            removeItemQuestion: 'Are you sure you want to delete this item forever?',
            restoreQuestion: 'Are you sure you want to restore the document from the archive?',
            retiredActivityConfirm: 'Seafarer is marked as Retired. Are you sure you want to add a new activity?',
            returnExpenseToPendingQuestion: 'Are you sure you want to return expense to "Pending" status?',
            saveDocumentChecklistFirstToAddItems: 'Save Document Checklist to add items!',
            saveWageTemplateFirstToAddItems: 'Save Wage Template first to add items!',
            saveSeafarerBeforeOthers:
                "Are you sure you want to exit without saving? In order to save other data, you must first fill in and save the 'Profile' tab.",
            seafarerActivityNoRecords:
                'This seafarer has no records in activity log, please add activity for seafarer!',
            sectionsNotSaved: 'Changes were not saved for: %sections%. Please try again.',
            selectContractType: 'Please select Contract type to Issue new Contract',
            selectEntity: 'Please select Entity!',
            selectLevel: 'Please select level',
            selectMaritimeObject: 'Please select first Maritime Object!',
            selectSeafarer: 'Select seafarer first!',
            sendToBillingExpenseQuestion:
                'Are you sure you want to send this expense to billing? This action is irreversible!',
            sendPayslipEmail: 'Would you like to e-mail this document to seafarer?',
            sendingTimesheetsToBilling:
                "Confirming this action will send all timesheets for this Entity to billing. \nOnce sent to billing, activity log changes won't affect those timesheets. Would you like to proceed?",
            startDateActivityError:
                'Start date on new Activity is before or on same date as last activity, please adjust last activity or change start date!',
            timesheetsSuccesfulyGeneratedAndApproved: 'Timesheets generated and approved succesfully!',
            timesheetsSuccessfulSentToBilling: 'All timesheets for this Entity succesfully sent to Billing!',
            updateListQuestion:
                'Updating Document Checklist will result in loss of progress. Would you like to proceed?',
            updateTimesheetQuestion:
                'Confirmation of this action will result in an updated timesheet that you can again send to billing',
            uploadFile: 'Please upload file',
            userExists: 'There is a user with the same e-mail address!',
            vatLength: 'VAT is not valid',
            writeNote: 'Please write note before saving',
            invoiceDueDateError: 'The due date can not be before the issue date.',
            invoicesInvalidYear: 'You cannot change the year of the invoice.',
            invoicesInvalidSequenceEarlier: 'Earlier invoice with higher number already exists.',
            invoicesInvalidSequenceLater: 'Later invoice with lower number already exists.',
            invoiceMissingExchangeRate: 'Exchange rate is not available for one of the invoice item currencies or dates.',
            voidQuestion:
                'Voiding of this invoice will result in a new invoice with all of the item quantities converted to negative values. Would you like to proceed?',
            noSeafarersSelected: 'There are no seafarers selected.',
            mailsSavedToClipboard: 'E-mails are saved to clipboard.',
            failedToSaveMails: 'Failed to save e-mails to clipboard.',
            codeIsInvalid: 'Entered code is invalid.',
            codeIsNotEntered: 'Please enter the code before verification.',
            seafarerGdprAnonymized: 'Seafarer is GDPR Anonymized.',
            doGdprAnonymization:
                'Are you sure you want to anonymize this Seafarer? Confirmation of this action will result in loss of all seafarer data and documents. Would you like to proceed?',
            syncBankData: 'Please sync bank data.',
            removeItemForeverQuestion: 'Are you sure you want to remove this item from billing list forever?',
            payslipIssued: 'Payslips have been issued.',
        },
        buttons: {
            add: 'Add',
            addActivity: 'Add Activity',
            addDocument: 'Add document',
            addItem: 'Add item',
            addToDatabase: 'Add to database',
            agencyFeeInformation: 'Agency fee information',
            all: 'All',
            alteration: 'Alteration',
            applyChanges: 'Apply changes',
            assign: 'Assign',
            back: 'Back',
            bulkPlan: 'Bulk plan',
            verify: 'Verify',
            regenerateCode: 'Regenerate code',
            cancel: 'Cancel',
            cancelContract: 'Cancel contract',
            cancelFilter: 'Cancel filters',
            cancelPlacement: 'Cancel placement',
            changeStatus: 'Change status',
            close: 'Close',
            confirm: 'Confirm',
            confirmContract: 'Confirm contract',
            confirmList: 'Confirm list',
            createPlanned: 'Create planned',
            createInvoice: 'Create invoice',
            createPlacement: 'Create placement',
            delete: 'Delete',
            determineAllContracts: 'Determine all contracts',
            edit: 'Edit',
            export: 'Export',
            forgottenPassword: 'Forgot your password?',
            filter: 'Filter.',
            generateAndApproveTimesheets: 'Generate timesheets and approve them',
            generateNewPassword: 'Send a new password',
            handleContractStatuses: 'Handle contract statuses',
            load: 'Load',
            loadItems: 'Load items',
            lock: 'Lock',
            login: 'Login',
            logout: 'Logout',
            new: 'New',
            newBillingList: 'New billing list',
            newContract: 'New contract',
            newPlan: 'New plan',
            no: 'No',
            ok: 'OK',
            profile: 'Profile',
            partial: 'Partial',
            payslipBreakdownExport: 'Payslip Breakdown Export',
            planSeafarer: 'Plan seafarer',
            pullDocuments: 'Pull documents',
            save: 'Save',
            saveAndExit: 'Save and exit',
            saveDraft: 'Save draft',
            send: 'Send',
            sendTimesheetsToBilling: 'Send approved timesheets/Expenses to billing',
            unlock: 'Unlock',
            updateList: 'Update list',
            yes: 'Yes',
            void: 'Void',
            updateData: 'Update data',
            updateTimesheet: 'Update timesheet',
            openInvoiceVoid: 'Open Invoice void',
            openVoidedInvoice: 'Open voided Invoice',
            preview: 'Preview',
            issuePayslips: 'Issue payslips',
            copyMails: 'Copy E-mails',
            copyFromAddress: 'Copy from address',
            exportCV: 'Export CV',
            gdprAnonymization: 'GDPR Anonymization',
            sync: 'Sync',
        },

        fields: {
            dataRange: 'Data Range',
            abbreviation: 'Abbreviation',
            accountCurrency: 'Account currency',
            accountName: 'Account name',
            accountHolderName: "Account holder's name",
            accountHolderSName: "Account holder's name",
            actions: 'Actions',
            active: 'Active',
            activityStatus: 'Activity (status)',
            additionalInformation: 'Additional information',
            address: 'Address',
            age: 'Age',
            agFee: 'Ag. Fee',
            agencyFee: 'Agency fee',
            allApproved: 'All approved',
            allBilling: 'All billing',
            amount: 'Amount',
            available: 'Available',
            applied: 'Applied',
            applications: 'Applications',
            applyAgencyFee: 'Apply agency fee',
            approved: 'Approved',
            asap: 'ASAP',
            archiveList: 'Archive list',
            assignToVacancy: 'Assign to Vacancy',
            attitude: 'Attitude',
            availableDate: 'Available date',
            bank: 'Bank',
            bankAddress: 'Bank address',
            bankName: 'Bank name',
            bankPostCode: 'Bank post code',
            bankTown: 'Bank town',
            bankCity: 'Bank city',
            bankCountry: 'Bank country',
            bic: 'BIC',
            billingPeriodFrom: 'Billing period from',
            billingPeriodTo: 'Billing period to',
            birthNumber: 'Birth No.',
            boc: 'BOC',
            callSign: 'Call sign',
            cargoHandlingGear: 'Cargo handling gear',
            category: 'Category',
            cancelPlacement: 'Cancel placement',
            cancel: 'Cancel',
            cc: 'CC',
            city: 'City',
            client: 'Client',
            closestIntAirport: 'Closest int. airport',
            communication: 'Communication',
            companyName: 'Company name',
            complete: 'Complete',
            completePlacement: 'Complete placement',
            contractId: 'Contract ID',
            contractHeader: 'Contract header',
            contractStart: 'Contract start',
            contactEmail: 'Contact email',
            contactNumber: 'Contact number',
            country: 'Country',
            countryOfResidency: 'Country of residency',
            createdOn: 'Created on',
            currency: 'Currency',
            date: 'Date',
            dateAndPlaceOfBirth: 'Date and place of birth',
            dateCreated: 'Date created',
            dateModified: 'Date modified',
            dateApplied: 'Date applied',
            dateOfBirth: 'Date of birth',
            dateOfExpiry: 'Date of expiry',
            dayRate: 'Day rate',
            dayType: 'Day type',
            days: 'Days',
            dateIssued: 'Date issued',
            deadline: 'Deadline',
            details: 'Details',
            document: 'Document',
            documentCategory: 'Document category',
            documentNumber: 'Document number',
            documentNo: 'Document No.',
            documentType: 'Document name',
            dlProof: 'Dl proof',
            dpManufacturer: 'DP manufacturer',
            dpModel: 'DP model',
            dpType: 'DP type',
            dueDays: 'Due days',
            dueDateDays: 'Due date (days)',
            duration: 'Duration',
            durationDays: 'Duration (days)',
            durationMonths: 'Duration (months)',
            dwt: 'DWT',
            effectiveFrom: 'Effective from',
            effectiveTo: 'Effective to',
            email: 'E-mail',
            emailTo: 'E-mail to',
            emergencyContactName: 'Emergency contact name',
            emergencyContactRelationship: 'Emergency contact relationshiop',
            emergencyContactAddress: 'Emergency contact address',
            emergencyContactCountry: 'Emergency contact country',
            emergencyContactNumber: 'Emergency contact number',
            emergencyContactEmail: 'Emergency contact email',
            employer: 'Employer',
            endDate: 'End date',
            engineModel: 'Engine model',
            eoc: 'EOC',
            employerEntity: 'Employer - Entity',
            employerOffice: 'Employer - Office',
            engineType: 'Engine type',
            entities: 'Entitites',
            entitlementToReparation: 'Entitlement to reparation',
            exchangeRate: 'Exchange rate',
            expirationDate: 'Expiration date',
            expiryDate: 'Expiry date',
            fax: 'Fax',
            feeType: 'Fee type',
            file: 'File',
            files: 'Files',
            filters: 'Filters',
            firstName: 'Name',
            fixed: 'Fixed',
            fixedFee: 'Fixed fee',
            flightReservation: 'Flight reservation',
            fluent: 'Fluent',
            from: 'From',
            fullDay: 'Full day',
            fullHomeAddress: 'Full home address',
            gdpr: 'GDPR',
            gender: 'Gender',
            global: 'Global',
            globalCondition: 'Global condition',
            good: 'Good',
            gt: 'GT',
            healthAndSocialSecurityProtectionBenefits: 'Health and social security protection benefits',
            heightCm: 'Height (cm)',
            hired: 'Hired',
            homeAddress: 'Home address',
            hoursOfRestDay: 'Hours of rest day',
            iban: 'IBAN',
            id: 'ID',
            imo: 'IMO',
            imoNumber: 'IMO No.',
            inCimis: 'In CIMIS',
            information: 'Information',
            internalOffice: 'Internal office',
            inv: 'Inv',
            invoice: 'Invoice',
            invoiceNotes: 'Invoice notes',
            invoiceNumber: 'Invoice number',
            invoiceSum: 'Invoice sum',
            invoiceTo: 'Invoice to',
            invoiceTotal: 'Invoice total',
            invoicetoEntity: 'Invoice to (Entity)',
            invoiceTotalGross: 'Invoice total- Gross',
            invoiceTotalNet: 'Invoice total- Net',
            issueDate: 'Issue date',
            issuedBy: 'Issued by',
            item: 'Item',
            issuingCountry: 'Issuing country',
            joiningData: 'Joining date',
            jobRequirements: 'Job requirements',
            jobTitle: 'Job title',
            kW: 'kW',
            language: 'Language',
            lastModified: 'Last modified',
            lastModifiedBy: 'Last modified by',
            lastName: 'Surname',
            lastVessel: 'Last vessel',
            leave: 'Leave',
            level: 'Level',
            loaM: 'LOA(m)',
            loadFromTemplate: 'Load from template',
            log: 'Log',
            manager: 'Manager',
            maritalStatus: 'Marital status',
            maritimeObject: 'Maritime object',
            maritimeObjectOwner: 'Maritime object owner',
            maritimeObjectManager: 'Maritime object manager',
            maritimeObjects: 'Maritime objects',
            mergeSeafarerSalaryAndFixedAgencyFeeOnInvoice: 'Merge Seafarer Salary and Fixed Agency Fee on Invoice',
            middleName: 'Middle name',
            modifiedBy: 'Modified by',
            mutualPeriodOfNotice: 'Mutual period of notice',
            name: 'Name',
            nationalIdentifierOIB: 'National identifier (OIB)',
            nationality: 'Nationality',
            netDifference: 'Net difference',
            nextOfKinNameAddressPhone: 'Next of kin (name, address, phone)',
            nextPlannedDate: 'Next planned date',
            newPassword: 'New password',
            newPasswordConfirmation: 'Repeat new password',
            noPlacement: 'No placement',
            noProfficiency: 'No profficiency',
            note: 'Note',
            notes: 'Notes',
            notify: 'Notify',
            notifyBefore: 'Notify before',
            notifyBeforeDays: 'Notify before - days',
            notifyForExtension: 'Notify for extension',
            oib: 'OIB',
            officeFooter: 'Office footer',
            offBoard: 'Off board',
            oldPassword: 'Old password',
            onDate: 'On date',
            oneSpecificVoyageAndPossibleDuration: 'One specific voyage and possible duration',
            organisationRegNumber: 'Organisation Reg. No.',
            otherDay: 'Other day',
            overall: 'Overall',
            overallFeedback: 'Overall feedback',
            overallSize: 'Overall size',
            password: 'Password',
            passportNo: 'Passport No',
            paidAnnuaLleaveOrFormula: 'Paid annual leave or the formula used for calculating it',
            payslip: 'Payslip',
            paySlip: 'Pay slip',
            paysliptTotal: 'Payslip total',
            payslipTotalNet: 'Payslip total - Net',
            payUntil: 'Pay until',
            passwordChange: 'Change password',
            pendingAction: 'Pending action',
            percentage: 'Percentage',
            periodOfEmployment: 'Period of employment',
            perfomance: 'Perfomance',
            place: 'Place',
            placement: 'Placement',
            placements: 'Placements',
            placementId: 'Placement ID',
            placeOfBirth: 'Place of birth',
            plannedSignOn: 'Planned sign on',
            plannedDate: 'Planned date',
            poor: 'Poor',
            poNumber: 'PO number',
            portOfRegistry: 'Port of registry',
            possiblePlaceOTerminatingService: 'Possible place of terminating Service',
            positionsOffererdNo: 'Number of positions offered',
            postalCode: 'Post code',
            probationaryPeriod: 'Probationary period',
            probationaryPeriodDurationAndConditions: 'Duration and conditions for any probationary period',
            terminationProcedure: 'Procedure for termination of employment',
            normalWorkingDayAndWeek: 'Length of the normal working day and week',
            entitlementToCompetence: 'Entitlement to competence',
            otherLeave: 'Duration of any leave other than the annual leave',
            employerPhone: "Employer's phone number",
            propulsionPowerkW: 'Propulsion power (kW)',
            pumpingSystem: 'Pumping system',
            phone: 'Phone',
            ps: 'PS',
            qty: 'Qty',
            quarantineDay: 'Quarantine day',
            rank: 'Rank',
            ranks: 'Ranks',
            rate: 'Rate',
            reason: 'Reason',
            registrationDate: 'Registration date',
            remarks: 'Remarks',
            role: 'Role',
            rotation: 'Rotation',
            relationship: 'Relationship',
            rememberMe: 'Remeber me',
            registeredFlag: 'Registered flag',
            repeatPassword: 'Repeat password',
            routingNumber: 'Routing number',
            salary: 'Salary',
            salaryDetails: 'Salary details',
            schoolName: 'School name',
            seamansBookBo: "Seaman's book No",
            seafarer: 'Seafarer',
            seafarers: 'Seafarers',
            seafarerNationality: 'Seafarer nationality',
            seafarerStatus: 'Seafarer status',
            seafarerSalaryGoesThroughAzara: 'Seafarer salary goes through Azara',
            seamanBook: "Seaman's Book Number",
            search: 'Pretraga',
            selectHeaders: 'Select headers',
            seniority: 'Seniority',
            shoeSizeEur: 'Shoe size (eur)',
            shipBuilder: 'Shipbuilder',
            shipManager: 'Ship manager',
            sickDay: 'Sick day',
            signOff: 'Sign off',
            signOffDate: 'Sign off date',
            signOn: 'Sign on',
            signOnPlanned: 'Planned Sign on ',
            signOnDate: 'Sign on date',
            signedOn: 'Signed on',
            signedOff: 'Signed off',
            sum: 'Sum',
            specialConditionsOtherInformation: 'Special conditions, other information',
            startDate: 'Start date',
            standbyDay: 'Standby day',
            status: 'Status',
            streetNameAndNumber: 'Streeet name and number',
            substitueFor: 'Substitute for',
            surname: 'Surname',
            swiftCode: 'Swift code',
            targetCurrency: 'Target currency',
            targetValue: 'Target value',
            template: ' Template',
            temporaryEmployment: 'Temporary employment',
            to: 'To',
            total: 'Total',
            totalAmount: 'Total amount',
            town: 'Town',
            trainingDay: 'Training day',
            travelInfo: 'Travel info',
            travelDay: 'Travel day',
            type: 'Type',
            typeOfvessel: 'Type of Vessel',
            ulProof: 'Ul proof',
            user: 'User',
            value: 'Value',
            vat: 'Vat',
            vatPercentageSimbol: 'Vat (%)',
            vatApplicable: 'Vat applicable',
            vatExemptionComment: 'Vat exemption comment',
            vatId: 'Vat ID',
            vatPercentage: 'Vat (%)',
            vessel: 'Vessel',
            vesselAge: 'Vessel age',
            vesselExperience: 'Vessel experience',
            vesselFlag: 'Vessel flag',
            vesselInformation: 'Vessel information',
            vesselManager: 'Vessel manager',
            vesselName: 'Vessel name',
            vessels: 'Vessels',
            vesselSize: 'Vessel size',
            vesselType: 'Vessel type',
            weightKg: 'Weight (kg)',
            wagesFromAndIncluding: 'Wages from and including',
            withAzaraFrom: 'With AZARA from',
            withCompanyFrom: 'With company from',
            yearBuilt: 'Year built',
            number: 'Number',
            billingList: 'Billing list',
            netValue: 'Net value',
            vatValue: 'VAT value',
            totalValue: 'Total value',
            totalValueInEur: 'Total value in EUR',
            poNumbers: 'PO numbers',
            office: 'Office',
            account: 'Account',
            sequence: 'Sequence',
            entity: 'Entity',
            entityHeader: 'Entity header',
            entityFooter: 'Entity footer',
            dateOfIssue: 'Issue date',
            timeOfIssue: 'Issue time',
            deliveryDate: 'Delivery date',
            dueDate: 'Due date',
            phoneNumber: 'Phone number',
            placeOfIssue: 'Issue place',
            paymentMethod: 'Method of payment',
            operator: 'Operator',
            officeAccount: 'Office account',
            invoiceDate: 'Invoice date',
            totalAmountGross: 'Total amount - gross',
            totalAmountNet: 'Total amount - net',
            paid: 'Paid',
            earnings: 'Earnings',
            existingSeafarer: 'Existing Seafarer',
            vesselExpirience: 'Vessel Expirience',
            rankExpirience: 'Rank Expirience',
            iataCode: 'IATA code',
            rating: 'Rating',
        },

        labels: {
            verifyGdprAnonymization: 'Verify GDPR Anonymization',
            pasteCode: 'Paste the code below:',
            dontSeeCode: "Don't see the code?",
            selectInvoiceCurrency: 'Odaberite valutu računa (lista sadrži više valuta)',
            startDate: 'Start Date',
            endDate: 'End Date',
            validity: 'VALIDITY:',
            selectAll: 'Select all',
            accounts: 'Accounts',
            activityEdit: 'Edit Activity',
            address: 'Address',
            addressAndContactInfo: 'Address & Contact information',
            addDocument: 'Add document',
            addItem: 'Add item',
            agreedSalaries: 'Agreed salaries',
            all: 'All',
            and: 'And',
            additional: 'Additional',
            additionalFilters: 'Additional filters',
            applied: 'Applied',
            applicationInformation: 'Application information',
            applications: 'Applications',
            applyAgencyFeeOn: 'Apply agency fee on:',
            bankAccount: 'Bank Account',
            bankAccountDetails: 'Bank Account details',
            billingListInformation: 'Billing list information',
            bodyMetrics: 'Body metrics',
            bulkChangeStatus: 'Bulk change status',
            candidateAddressInformation: 'Candidate address information',
            candidateDocuments: 'Candidate documents',
            candidateEducation: 'Candidate education',
            candidateInformation: 'Candidate information',
            candidateLanguages: 'Candidate languages',
            candidateNextOfKinInformation: 'Candidate next of kin information',
            candidateProfileInformation: 'Candidate profile information',
            candidateSeaService: 'Candidate sea service',
            changeStatusCrewlistLabel: 'Please review and confirm the following actions on ',
            checklistTemplateUpdatedOn: 'Document Checklist template was last updated on ',
            checklistLastUpdated: 'Document Checklist was last updated on \n',
            companies: 'Companies',
            companyExpenses: 'Company expenses',
            confirmedBillingLists: 'Confirmed billing lists',
            confirmNewContractStartDate: 'Confirm start date for new contract',
            contractDetails: 'Contract details',
            contacts: 'Contacts',
            contractsNearExpiration: 'Contracts near expiration (next 7 days)',
            communication: 'Communication',
            createPlannedPlacement: 'Create planned placement',
            dark: 'Dark',
            days: 'Days',
            documentNearExpiration: 'Document near expiration (next 90 days)',
            draftBillingLists: 'Draft billing lists',
            dragdropMultiple: 'Drag and drop files',
            dragdropSingle: 'Drag and drop file',
            dyslexicFont: 'Dyslexic font',
            edit: 'Edit',
            editDocument: 'Edit document',
            editExpense: 'Edit expense',
            editItem: 'Edit item',
            education: 'Education',
            effectiveFrom: 'Effective from:',
            employer: 'Employer',
            employeer: 'Employeer',
            entity: 'Entity',
            entityDetails: 'Entity details',
            experienceInRank: 'Experience in rank',
            experienceWithAzara: 'Experience with Azara',
            experienceWithOtherCompanies: 'Experience with other companies',
            fontSize: 'Font size',
            forSpecifiedPeriod: 'For specified period',
            from: 'from',
            hired: 'Hired',
            invoiceDetails: 'Invoice details',
            invoices: 'Invoices',
            issuedContracts: 'Issued contracts',
            joiningSeafarers: 'Joining seafarers',
            languages: 'Languages',
            large: 'Large',
            lastestApplications: 'Latest application',
            level: 'Level',
            light: 'Light',
            loadItems: 'Load items',
            logout: 'Logout',
            maritimeObject: 'Maritime object',
            maritimeObjectContactDetails: 'Maritime object contact details',
            maritimeObjectContractDetails: 'Maritime object contract details',
            maritimeObjectDetails: 'Maritime object details',
            monthlyBreakdown: 'Monthly breakdown',
            months: 'months',
            months2: 'Months',
            no: 'No',
            noResults: 'No results.',
            new: 'New',
            newDocument: 'New document',
            newEducation: 'New education',
            newExpense: 'New expense',
            newExperienceWithAzara: 'New experience with azara',
            newExperienceWithOtherCompanies: 'New experience with another company',
            newLanguage: 'New language',
            newOnShoreExperience: 'New on shore experience',
            newSeaExperienceWithOtherCompanies: 'New sea experience with other companies',
            newSeafarer: 'New seafarer',
            nextOfKinNOK: 'Next of Kin (NOK)',
            noData: 'No data',
            notes: 'Notes',
            onBoard: 'On board',
            of: 'of',
            offBoard: 'Off board:',
            officeLogo: 'Office logo',
            onshoreExperience: 'On shore experience',
            page: 'Page',
            personalInformation: 'Personal information',
            phase: 'Phase',
            placement: 'Placement',
            placementPreparation: 'Placement preparation',
            placements: 'Placements',
            placementStatus: 'Placement status',
            plannedAndJoining: 'Planned & joining',
            plannedSeafarers: 'Planned seafarers',
            plannedSignOn: 'Planned sign-on:',
            plannedOn: 'Planned on:',
            planMultipleSeafarers: 'Plan multiple seafarers',
            pointOfContact: 'Point of contact',
            profile: 'Profil',
            rating: 'Rating',
            relevantDates: 'Relevant dates',
            reportForActionsOn: 'Report for actions on',
            rowsPerPage: 'Rows per page:',
            since: 'Since:',
            seafarer: 'Seafarer',
            settings: 'Settings',
            seafarerContractDaysStatistics: 'Seafarer contract days',
            seafarerExpenses: 'Seafarer expenses',
            seafarerInformation: 'Seafarer information',
            seafarerName: 'Seafarer name:  ',
            seafarerStatus: 'Seafarer status',
            show: 'Show: ',
            showInactives: 'Show inactive',
            small: 'Small',
            success: 'Success',
            sickLeave: 'Sick leave',
            termsOfTheAgreement: 'Terms of the agreement',
            termsOfEmployment: 'Terms of employment',
            theme: 'Theme',
            to: 'to',
            toBeCompletedOnlyInCaseOfTemporaryEmployment: 'To be completed only in case of temporary employment',
            totalRecords: 'Total records:',
            trainingVisaEtc: 'Training/visa/etc.',
            travelArrangements: 'Travel arrangements',
            travelFromVessel: 'Travel from vessel',
            travelToVessel: 'Travel to vessel',
            upload: 'One file',
            uploadMultiple: 'Mulitple files',
            uploadInProgress: 'Upload in progress.',
            vacancyInformation: 'Vacancy information',
            vatInformation: 'Vat information',
            vacancyMetrics: 'Vacancy metrics',
            verifyContractDetermination: 'Verify contract cancellation!',
            vesselDetails: 'Vessel details',
            vesselName: 'Vessel name:  ',
            yourData: 'Your data',
            yes: 'Yes',
            wageInformation: 'Wage information',
            wagesOvertimePayAndOtherConditions:
                'Wages overtime and other conditions according to collective agreement between',
            totals: 'TOTALS',
            provider: 'PROVIDER',
            customer: 'CUSTOMER',
            general: 'GENERAL',
            issuePayslips: 'Issue payslips',
        },
        modules: {
            application: 'Application',
            applications: 'Applications',
            bank: 'Bank',
            banks: 'Banks',
            billing: 'Billing',
            bilingLists: 'Billing lists',
            databases: 'Databases',
            contract: 'Contract',
            contracts: 'Contracts',
            crewList: 'Crew list',
            dashboard: 'Dashboard',
            documentType: 'Document name',
            documentTypes: 'Document names',
            entity: 'Entity',
            entities: 'Entities',
            finances: 'Finances',
            internalOffice: 'Internal Office',
            internalOffices: 'Internal Offices',
            invoicing: 'Invoicing',
            login: 'Login',
            maritimeObjects: 'Maritime Objects',
            maritimeObject: 'Maritime object',
            newApplication: 'New Application',
            newDocumentType: 'New Document Name',
            newEntity: 'New Entity',
            newMaritimeObject: 'New Maritime Object',
            newPlacement: 'New placement',
            newRank: 'New rank',
            newBank: 'New bank',
            newSeafarer: 'New Seafarer',
            newUserAccount: 'New user account',
            newVacancy: 'New vacancy',
            otherDatabases: 'Other Databases',
            payroll: 'Payroll',
            payrolles: 'Payrolles',
            placement: 'Placement',
            placements: 'Placements',
            projects: 'Projects',
            profile: 'My profile',
            rank: 'Rank',
            ranks: 'Ranks',
            reports: 'Reports',
            seafarer: 'Seafarer',
            seafarers: 'Seafarers',
            statistics: 'Statistics',
            showcase: 'Showcase',
            users: 'Users',
            userAccount: 'User Account',
            userAccounts: 'User accounts',
            vacancy: 'Vacancy',
            vacancies: 'Vacancies',
            newInvoice: 'New invoice',
            invoices: 'Invoices',
            payslips: 'Payslips',
            airport: 'Airport',
            newAirport: 'New airport',
            airports: 'Airports',
        },

        tabs: {
            activityLog: 'Activity log',
            additional: 'Additional',
            allContracts: 'All contracts',
            applicationInformation: 'Application information',
            contracts: 'Contracts',
            documentArchive: 'Document archive',
            documentChecklist: 'Document Checklist',
            documents: 'Documents',
            expenses: 'Expenses',
            maritimeObjectInformation: 'Maritime object information',
            navigation: 'Navigation',
            placements: 'Placements',
            placementInformation: 'Placement information',
            profile: 'Profile',
            salary: 'Salary',
            seaService: 'Sea service',
            templates: 'Templates',
            wageTemplate: 'Wage template',
        },

        texts: {
            passwordReset: `If you have forgotten your password, you can request an e-mail with a new password here.`,
        },

        tooltips: {
            deleteForever: 'Delete forever',
            accessibilitySettings: 'Accessibility settings',
            activate: 'Activate',
            approveExpense: 'Approve expense',
            additionalFilters: 'Additional filters',
            allItemsAreApproved: 'All items are approved',
            allItemsSentToBilling: 'All items are sent to billing',
            approve: 'Approve',
            approved: 'Approved',
            archive: 'Archive',
            createPlacement: 'Create placement',
            delete: 'Delete',
            download: 'Download',
            downloadOriginal: 'Download original',
            edit: 'Edit',
            excel: 'Excel export',
            filter: 'Filter',
            goToPlannedPlacement: 'Go to planned placement',
            goToContractPlacement: 'Go to contract placement',
            logout: 'Logout',
            mustEditActivity: 'You must edit activity for active contract!',
            openApplication: 'Open application',
            openEntityInNewTab: 'Open Entity',
            openMaritimeObjectInNewTab: 'Open Maritime object',
            openInNewTab: 'Open in new tab',
            openPlacement: 'Open placement',
            openSeafarer: 'Open seafarer',
            openSeafarerActivity: 'Open seafarer activity',
            openSeafarerDocuments: 'Open seafarer documents',
            openVacancyInNewTab: 'Open Vacancy in new tab!',
            positionDown: 'Position down',
            positionUp: 'Position up',
            pleaseEditActivitLog: 'Please edit activity log for this seafarer',
            returnToPending: 'Return to pending',
            rejectExpense: 'Reject expense',
            resetFilters: 'Reset filters',
            restore: 'Restore',
            seafarerHasNoDocument: 'Seafarer has no documents!',
            seeMore: 'See more',
            selectHeaders: 'Select headers',
            sendDocument: 'Send document',
            sendToBilling: 'Send to billing',
            settings: 'Settings',
            thereAreUnapprovedItems: 'There are Items that are not approved',
            thereAreItemsNotSentToBilling: 'There are Items that are not sent to billing',
            pdf: 'PDF',
            zip: 'ZIP',
            webRegistrations: 'Web registrations',
        },
    };
}
